import { AppHeader } from '../components/app-header';
import { SearchForm } from '../components/search-form';

export default function SearchPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <AppHeader />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <SearchForm />
      </main>
    </div>
  );
}
